import React, { useContext } from 'react';
import { DataContext } from '../contexts/DataContext';
import SupplyChainSection from '../components/SupplyChainSection/SupplyChainSection';
import { MetricCard } from '../components/Metrics';
import { calculateEmissionSegmentsFromJSON } from '../utils/emissionSegmentUtils';
import { useTranslation } from 'react-i18next';
import { getSafeText } from '../utils/valueResolver';

function ManufacturingEnvironmentPage() {
  const { data } = useContext(DataContext);
  const { t } = useTranslation();

  const supplyChainInfo = data.SupplyChainInfo;

  const createSection = (type, stepId, title, info, isOpen = false, companyName = null) => ({
    type,
    stepId,
    title,
    location: getSafeText(info.region),
    company: getSafeText(companyName) || getSafeText(info.company),
    energyConsumption: `${info.energyConsumption}kWh`,
    co2Emission: (
      <>
        {info.co2Emission}
        <span className="emissions-unit">kg-CO<sub>2</sub></span>
      </>
    ),
    co2Absorption: info.co2Absorption ? (
      <>
        {info.co2Absorption}
        <span className="emissions-unit">kg-CO<sub>2</sub></span>
      </>
    ) : null,
    features: (info.environmentalEfforts?.effortsGroups?.[0]?.efforts || []).map((effort) => ({
      effortDescription: getSafeText(effort.effortDescription),
      effortUrl: effort.effortUrl,
      referenceUrl: effort.referenceUrl
    })),
    certificateLink: info.environmentalEfforts?.effortsGroups?.[0]?.effortUrl,
    linkType: info.environmentalEfforts?.effortsGroups?.[0]?.effortUrl ? 'certificate' : 'website',
    isOpen
  });

  const sections = [
    createSection('material', 1, t('supplyChain.material'), supplyChainInfo.rawMaterial, true, 'KINGDOM'),
    createSection('spinning', 2, t('supplyChain.spinning'), supplyChainInfo.spinning, false, 'KINGDOM'),
    createSection('weaving', 3, t('supplyChain.weaving'), supplyChainInfo.weaving, false, 'KINGDOM'),
    createSection('sewing', 4, t('supplyChain.sewing'), supplyChainInfo.sewing, false, '常州市虹亚服饰有限公司'),
    createSection('dyeing', 5, t('supplyChain.dyeing'), supplyChainInfo.dyeing, false, '上海南宝服装水洗有限公司')
  ];

  const emissionSegments = calculateEmissionSegmentsFromJSON(data);

  return (
    <>
      <div className="box-left">
        <MetricCard emissionSegments={emissionSegments} />
      </div>
      <div className="box-right">
        <SupplyChainSection sections={sections} />
      </div>
    </>
  );
}

export default ManufacturingEnvironmentPage;
